import { ApplicationService } from './services/application.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationData } from './data/application.data';
import { Configuration } from './data/configuration.data';
import { environment } from 'src/environments/environment';
import { ModalService } from './services/modal.service';
import { FontsLibrairie } from './data/fonts.librairie';

declare let FastClick:any;
declare let Stats:any;
declare const fabric: any;

declare const initDatas: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit{


  public appReady:boolean = false;

  /**
   * Constructor
   */
  constructor(
    private applicationData:ApplicationData,
    private translate:TranslateService,
    private applicationService:ApplicationService,
    private modalService:ModalService
  ) {

    this.applicationData.lang = initDatas.lang;
    translate.setDefaultLang('en');
    translate.use(initDatas.lang);

    this.applicationData.configuration = new Configuration();
    this.applicationData.configuration.productFamilyId = initDatas.productFamily.id;
    this.applicationData.configuration.sheetId = initDatas.sheet.id;
    this.applicationData.configuration.designFamilyId = initDatas.design.designFamilyId;

    if (fabric.isWebglSupported()) {
      //fabric.textureSize = 8192;
    }

    this.init();

      fabric.Image.filters.BlendColor.prototype.fragmentSource.hardlight =
      'if (gl_FragColor.r < 0.5) {\n' +
        'gl_FragColor.r *= 2.0 * uColor.r;\n' +
      '} else {\n' +
        'gl_FragColor.r = 1.0 - 2.0 * (1.0 - uColor.r) * (1.0 - gl_FragColor.r);\n' +
      '}\n' +
      'if (gl_FragColor.g < 0.5) {\n' +
        'gl_FragColor.g *= 2.0 * uColor.g;\n' +
      '} else {\n' +
        'gl_FragColor.g = 1.0 - 2.0 * (1.0 - uColor.g) * (1.0 - gl_FragColor.g);\n' +
      '}\n' +
      'if (gl_FragColor.b < 0.5) {\n' +
        'gl_FragColor.b *= 2.0 * uColor.b;\n' +
      '} else {\n' +
        'gl_FragColor.b = 1.0 - 2.0 * (1.0 - uColor.b) * (1.0 - gl_FragColor.b);\n' +
      '}\n';





    if (environment.PRODUCTION == false) {
      //(function () { var script = document.createElement('script'); script.onload = function () { var stats = new Stats(); document.body.appendChild(stats.dom); requestAnimationFrame(function loop() { stats.update(); requestAnimationFrame(loop) }); }; script.src = '//mrdoob.github.io/stats.js/build/stats.min.js'; document.head.appendChild(script); })();
    }

  }

  /**
   * Init App
   */
  public init():void {
    FastClick.attach(document.body);
  }

  ngOnInit():void {
    this.applicationService.init().then(
      (result: any) => {
        setTimeout(() => {
          this.appReady = true;
        }, 1000);

      },
      (error: any) => {
        if(FontsLibrairie.fontErrors.length > 0){
          this.modalService.open('modal-project-error-font', {});
        }
        console.log('ko :(', error,FontsLibrairie.fontErrors);
      },
    );
  }


}
